import store from 'store'
import actions from './actions'

const STORED_SETTINGS = storedSettings => {
  const settings = {}
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

/* const clientWidth = () => {
  return Math.max(window.innerWidth, document.documentElement.clientWidth)
}
const clientHeight  = () => {
  return Math.max(window.innerHeight, document.documentElement.clientHeight)
}

clientWidth();
clientHeight(); */

const sideMenu=window.localStorage.getItem('isSideMenu')
/* console.log("=====window.innerWidth<======",window.innerWidth)
console.log("=====window.innerHeight<======",window.innerHeight) */
const initialState = {
  ...STORED_SETTINGS({
    locale: 'en-US',
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: true,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    isMenuShadow: false,
    isMenuUnfixed: false,
    menuLayoutType: sideMenu==="Y" || window.innerWidth<=552?'left':'nomenu', // left, top, top-dark, nomenu
    menuType: 'default', // default, flyout, compact
    menuColor: 'white', // dark, blue, gray, white
    flyoutMenuColor: 'blue', // dark, blue, gray, white
    systemLayoutColor: 'gray', // white, dark, blue, gray, image
    isTopbarFixed: true,
    isFooterDark: false,
    isContentNoMaxWidth: false,
    isAppMaxWidth: false,
    isGrayBackground: false,
    isGrayTopbar: false,
    isCardShadow: false,
    isSquaredBorders: false,
    isBorderless: false,
    routerAnimation: 'slide-fadein-up', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
  }),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
